import React from "react";

import { Col } from "reactstrap";
import { H4, P } from "../../../AbstractElements";
import { New } from "../../../Constant";
import ChartistBox from "../../General/ChartistBox";
import { hexToRgb } from "../../../Utils/helper/HexToRgb";
import ReactApexChart from "react-apexcharts";

const WidgetCaredSub = (props) => {
  const radialChart_1 = {
    series: [75],
    chart: {
      height: 90,
      type: "radialBar",
      offsetX: -5,
      offsetY: -15,
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "35%",
        },
        track: {
          background: "var(--theme-default)",
          opacity: 0.2,
        },
        dataLabels: {
          value: {
            color: "var(--tag-text-color--edit)",
            fontSize: "10px",
            show: true,
            offsetY: -12,
          },
        },
      },
    },
    colors: ["var(--theme-default)"],

    stroke: {
      lineCap: "round",
    },
  };
  return (
    <Col sm="6" className="p-0">
      <div className="d-flex align-items-center gap-md-0">
        {props.type === "bar" && (
          <div className="earnings-small-chart">
            <div className="small-bar">
              <div className="small-chart flot-chart-container">
                <ChartistBox options={props.options} data={props.chartData} />
              </div>
            </div>
          </div>
        )}
        {props.type === "radial" && (
          <div className="knob-block text-center">
            <ReactApexChart className="widgetsChart" options={props.chartData} series={props.chartData.series} type="radialBar" height={120} width={120} />
          </div>
        )}

        <div className="flex-grow-1">
          <div className="right-chart-content">
            <H4>
              {props.type === "bar" && "$"}
              {props.cardData.price}
              {props.type === "bar" ? "" : "k"}
            </H4>
            <P>
              {props.cardData.title} <span className={`badge ${props.color ? `badge-${props.badgeColor}` : "badge-primary"}`}>{New}</span>
            </P>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default WidgetCaredSub;
